import ScrollToElement from "common/utils/ui/scroll-to-element";
import "./digital-assets-plp-wrapper.scss";

export class DigitalAssetsPLP {
  #plpSelector = "";

  constructor(
    options = {
      plpSelector: ""
    }
  ) {
    this.#plpSelector = options.plpSelector;

    this.scrollToDigitalAssets();
  }

  get plpSelector() {
    return this.#plpSelector;
  }

  scrollToDigitalAssets() {
    const url = new URL(window.location.href);
    const creatorParam = url.searchParams.get("creator");

    if (creatorParam) {
      ScrollToElement.scrollToElementBySelector(this.plpSelector);
    }
  }
}

export default () =>
  new DigitalAssetsPLP({
    plpSelector: ".js-digital-assets-plp-wrapper"
  });
